<template>
  <div
    v-if="plan_expanded"
    class="relative p-4 mb-4 border rounded-md dark:bg-dark-screen-background dark:border-dark-divider-border dark:text-white">
    <div class="flex items-center">
      <ToggleStatusButton :object="plan" />
      <div class="ml-2">
        {{ plan.name }}
      </div>
      <div class="absolute flex -right-3 -top-3 gap-x-2">
        <div
          class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
          @click="plan_expanded = !plan_expanded">
          <div class="w-[15px] h-[15px] ml-[5px] mt-[0px] border-b-[3px] border-b-[#45D72D]" />
          <span
            class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
            {{ $t("Minimize") }}</span>
        </div>
        <div
          class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
          @click="handleViewPlan(plan)">
          <Maximize2 class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" color="#2DA7D7" />
          <span
            class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
            {{ $t("View Plan") }}</span>
        </div>
        <!-- <div
                      class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                      @click="handleRemovePlan(plan)">
                      <X
                        color="#FF0000"
                        class="w-3 h-3 ml-[7px] mt-[7px] transition ease-in-out duration-side-menu-transition-duration" /><span
                          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                          Remove</span>
                    </div> -->
      </div>
    </div>
    <div class="flex w-full mt-5">
      <div class="w-1/3">
        <div class="flex flex-row items-center gap-2 mt-2">
          <div class="text-common-grey">
            {{ $t("Type") }}:
          </div>
          <div>
            {{ $utils.capitalize(plan.type.replace("_", " ")) }}
          </div>
        </div>
      </div>

      <div class="w-1/3">
        <div class="flex flex-row items-center gap-2">
          <div class="text-common-grey whitespace-nowrap">
            {{ $t("Due Date") }}:
          </div>

          <div class="flex items-start justify-start w-1/12 py-2 text-start whitespace-nowrap text-md">
            <span v-if="plan.due_date">
              {{ $moment(plan.due_date).format("DD MMM  YYYY") }}
            </span>

            <span v-else> - </span>
          </div>
        </div>
      </div>

      <div :class="[`${plan.collaborators.length > 4 ? 'w-[16%]' : ''}`]" class="ml-auto -mt-8">
        <div :class="[`${plan.collaborators.length > 4 ? '' : '-ml-10'}`]" class="mb-2 text-common-grey whitespace-nowrap text-start">
          {{ $t("Team Members") }}
        </div>
        <div class="flex items-center -ml-5 -space-x-4 overflow-hidden">
          <span v-for="user in plan.collaborators.slice(0, 4)" :key="user" class="inline-block has-tooltip">
            <img
              v-if="$utils.getUserById(user, 'avatar')"
              class="inline-block rounded-full h-9 w-9 object-cover"
              :src="$utils.getUserById(user, 'avatar')"
              onerror="this.onerror=null; this.src=window.default_avatar;"
              alt="">
            <Avatar v-else :first-name="$utils.getUserById(user, 'first_name')" :last-name="$utils.getUserById(user, 'last_name')" />
            <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
              <div class="">
                <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                  {{ $utils.getUserById(user, "full_name") }}
                </p>
              </div>
            </span>
          </span>
          <span
            v-if="plan.collaborators.length > 4"
            class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
            + {{ plan.collaborators.length - 4 }} {{ $t("more") }}</span>
        </div>
      </div>
    </div>
  </div>

  <div
    v-else
    class="relative flex p-4 mb-4 align-middle border rounded-md dark:bg-dark-screen-background dark:border-dark-divider-border dark:text-white">
    <div
      :class="[
        'w-4 h-4 rounded-full mt-1 mr-4 relative',
        {
          'bg-dark-brand-blue': ['in-progress', 'pending'].includes(plan.status),
          'bg-status-warning-yellow': plan.status == 'overdue',
          'bg-status-success-green': plan.status == 'completed',
          'bg-status-error-red': ['cancelled', 'missed'].includes(plan.status)
        }
      ]" />
    <div>{{ plan.name }}</div>

    <div class="absolute flex -right-3 -top-3 gap-x-2">
      <div
        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
        @click="plan_expanded = !plan_expanded">
        <div class="w-[15px] h-[15px] ml-[5px] mt-[5px] border-[3px] rounded-md border-[#45D72D]" />
        <span
          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
          {{ $t("Expand") }}</span>
      </div>
      <div
        class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:bg-dark-screen-background dark:border-dark-divider-border"
        @click="handleViewPlan(plan)">
        <Maximize2 class="w-5 h-5 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" color="#2DA7D7" />
        <span
          class="tooltip whitespace-nowrap inline-flex items-center px-2 py-1 rounded-md text-sm w-[80px] bg-light-screen-background dark:bg-dark-screen-background font-medium dark:text-dark-body-text gap-2">
          {{ $t("View Plan") }}</span>
      </div>
      <!-- <div
                    class="bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
                    @click="handleRemovePlan(plan)">
                    <X
                      color="#FF0000"
                      class="w-3 h-3 ml-[7px] mt-[7px] transition ease-in-out duration-side-menu-transition-duration" /><span
                        class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                        Remove</span>
                  </div> -->
    </div>
  </div>
</template>

<script>
import ToggleStatusButton from "@/components/shared/ToggleStatusButton.vue"
import { Maximize2 } from "lucide-vue-next"
import Avatar from "@/components/shared/Avatar.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { ToggleStatusButton, Maximize2, Avatar },
  props: { plan: null },
  emits: [],
  data() {
    return {
      plan_expanded: false
    }
  },
  watch: {},

  created() {},

  methods: {
    handleViewPlan(plan) {
      this.$emitter.emit(ALL_EMITTERS.UPDATE_PLAN, {
        plan: this.$utils.clone(plan)
      })
    }
  }
}
</script>
